window.bootstrap = require('bootstrap');
require('./csp-handlers');
require('./app');
require('./app.init');
require('./waves');
require('./sidebarmenu');
require('./custom');
require('./app-style-switcher');
const Highcharts = require('./highchartjs/highcharts.src');
window.Highcharts = Highcharts;
require('./file-upload');
// window.$ = window.jQuery = require('jquery');
// window.jQueryUI = require('jquery-ui');
